import React from 'react';
import { useLocalization } from 'src/utils/useLocalization';

import './buttonGroup.scss';

const ButtonGroup: React.FC<{
    brand: string;
    handler: Function;
    isCreditSelected: boolean;
}> = ({ brand, handler, isCreditSelected }) => {
    const { statusSummary } = useLocalization();
    const selectedClass = 'selected';

    const creditClasses = `${brand} ${isCreditSelected ? selectedClass : ''}`;
    const fundingClasses = `${brand} ${isCreditSelected ? '' : selectedClass}`;
    return (
        <div className='status-summary_button_group'>
            <button className={creditClasses} onClick={() => handler('credit')}>
                {statusSummary.LABEL_STATUS_SUMMARY_CREDIT_BT}
            </button>
            <button
                className={fundingClasses}
                onClick={() => handler('funding')}
            >
                {statusSummary.LABEL_STATUS_SUMMARY_FUNDING_BT}
            </button>
        </div>
    );
};

export default ButtonGroup;
